// import { removeItem } from "../storage/local";
// function handleNoConnection() {}
// export function fetchWrapper(baseURI, { onBeforeStart = () => {}, onEnd = () => {} } = {}) {
// 	return async function fetch(
// 		endpoint,
// 		{ method = "GET", data, headers: customHeaders = {}, formData, ...customConfig } = { method: "GET", headers: {} },
// 		{ returnWholeResponse = false, returnWholeError = false, signal } = {
// 			returnWholeResponse: false,
// 			returnWholeError: false,
// 			signal: null,
// 		}
// 	) {
// 		try {
// 			if (!endpoint) {
// 				console.error('fetchWrapper: Endpoint is null or undefined', { baseURI, method });
// 				throw new Error('Endpoint cannot be null or undefined');
// 			}
// 			console.log('fetchWrapper: Calling endpoint', { baseURI, endpoint, method });
// 			onBeforeStart();
// 			const config = {
// 				method: method,
// 				headers: {
// 					"Content-Type": data ? "application/json" : undefined,
// 					...customHeaders,
// 				},
// 				credentials: "include",
// 				...customConfig,
// 			};
// 			if (signal) {
// 				config.signal = signal;
// 			}

// 			let url = `${baseURI}${endpoint}`;
// 			if (method !== "GET") {
// 				config.body = formData ? formData : data ? JSON.stringify(data) : undefined;
// 			}
// 			if (method === "GET" && data) {
// 				const _url = new URL(url);
// 				Object.keys(data).forEach((key) => {
// 					const values = Array.isArray(data[key]) ? data[key] : [data[key]];
// 					values.forEach((item) => {
// 						_url.searchParams.append(key, item);
// 					});
// 				});
// 				url = _url.toString();
// 			}

// 			if (formData) delete config.headers["Content-Type"];

// 			const response = await window.fetch(url, config);
// 			if (response.status === 0) {
// 				onEnd();
// 				return handleNoConnection();
// 			}

// 			// List of public endpoints that don't require authentication
// 			const publicEndpoints = [
// 				'/verify_email',
// 				'/login',
// 				'/register',
// 				'/account-type',
// 				'/set-password',
// 				'/send_verification_otp'
// 			];
			
// 			// Check if the current endpoint is public using flexible matching
// 			const isPublicEndpoint = publicEndpoints.some(publicEndpoint => 
// 				endpoint.endsWith(publicEndpoint) || publicEndpoint.endsWith(endpoint)
// 			);

// 			// For 401 responses, handle differently based on whether it's a public endpoint
// 			if (response.status === 401) {
// 				onEnd();
// 				if (!isPublicEndpoint) {
// 					removeItem("user");
// 					window.location.href = "/login";
// 					return Promise.reject(new Error("Unauthorized"));
// 				}
// 			}

// 			const responseBody = await response.json();

// 			if (response.ok && (response.headers.get("content-disposition") || "").includes("attachment")) {
// 				onEnd();
// 				return await response.blob();
// 			}

// 			if (response.status === 202) {
// 				onEnd();
// 				return void 0;
// 			}

// 			if (!response.ok) {
// 				onEnd();
// 				return Promise.reject(
// 					returnWholeError ? responseBody : responseBody.data ? responseBody.data.message : responseBody.message
// 				);
// 			}

// 			onEnd();
// 			return returnWholeResponse ? responseBody : responseBody.data || responseBody;
// 		} catch (error) {
// 			console.error(`Error while fetching ${endpoint}`, error);
// 			onEnd();
// 			return Promise.reject(error);
// 		}
// 	};
// }


import { removeItem } from "../storage/local";
function handleNoConnection() {}
export function fetchWrapper(baseURI, { onBeforeStart = () => {}, onEnd = () => {} } = {}) {
	return async function fetch(
		endpoint,
		{ method = "GET", data, headers: customHeaders = {}, formData, ...customConfig } = { method: "GET", headers: {} },
		{ returnWholeResponse = false, returnWholeError = false, signal } = {
			returnWholeResponse: false,
			returnWholeError: false,
			signal: null,
		}
	) {
		try {
			onBeforeStart();
			const config = {
				method: method,
				headers: {
					// Authorization: token ? `Bearer ${token}` : undefined,
					"Content-Type": data ? "application/json" : undefined,
					...customHeaders,
				},
				credentials: "include",
				...customConfig,
			};
			if (signal) {
				config.signal = signal;
			}

			let url = `${baseURI}${endpoint}`;
			if (method !== "GET") {
				config.body = formData ? formData : data ? JSON.stringify(data) : undefined;
			}
			if (method === "GET" && data) {
				const _url = new URL(url);
				Object.keys(data).forEach((key) => {
					const values = Array.isArray(data[key]) ? data[key] : [data[key]];
					values.forEach((item) => {
						_url.searchParams.append(key, item);
					});
				});
				url = _url.toString();
			}

			if (formData) delete config.headers["Content-Type"];

			const response = await window.fetch(url, config);
			if (response.status === 0) {
				onEnd();
				return handleNoConnection();
			}
			if (response.status === 401) {
				onEnd();
				removeItem("user");
				window.history.pushState({}, "", "/login");
			}
			if (response.ok && (response.headers.get("content-disposition") || "").includes("attachment")) {
				onEnd();
				return await response.blob();
			}
			if (response.status === 202) {
				return void 0;
			}
			const responseBody = await response.json();
			if (!response.ok) {
				onEnd();
				return Promise.reject(
					returnWholeError ? responseBody : responseBody.data ? responseBody.data.message : responseBody.message
				);
			}
			onEnd();
			return returnWholeResponse ? responseBody : responseBody.data || responseBody;
		} catch (error) {
			console.error(`Error while fetching ${endpoint}`, error);
			onEnd();
			return Promise.reject(error);
		}
	};
}